import * as React from 'react';
import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  TextSearch,
  Annotation,
  FormFields,
  FormDesigner,
  Inject,
} from '@syncfusion/ej2-react-pdfviewer';


function SyncfusionPDFViewer(props) {

    let {
        serviceUrl,
        documentPath,
        pathToSave,
        PageNavigationTool,
        MagnificationTool,
        PanTool,
        SelectionTool,
        SearchOption,
        DownloadOption,
        UndoRedoTool,
        AnnotationEditTool,
        FormDesignerEditTool,
        CommentTool,
        SubmitForm,
        style,
        saveDocument,
        documentSelected
    } = props

    let viewer;
    let toolbarItems = []
    if(PageNavigationTool) toolbarItems.push('PageNavigationTool')
    if(MagnificationTool) toolbarItems.push('MagnificationTool')
    if(PanTool) toolbarItems.push('PanTool')
    if(SelectionTool) toolbarItems.push('SelectionTool')
    if(SearchOption) toolbarItems.push('SearchOption')
    if(DownloadOption) toolbarItems.push('DownloadOption')
    if(UndoRedoTool) toolbarItems.push('UndoRedoTool')
    if(AnnotationEditTool) toolbarItems.push('AnnotationEditTool')
    if(FormDesignerEditTool) toolbarItems.push('FormDesignerEditTool')
    if(CommentTool) toolbarItems.push('UndoRedoTool')
    if(SubmitForm) toolbarItems.push('SubmitForm')

    function ajaxRequestInitiate(args) {
        if (args.JsonData['action'] === 'ExportFormFields') { 
          args.JsonData['path'] = pathToSave; // Provide the path here
          viewer.setJsonData(args.JsonData);
          saveDocument(documentSelected)
        }
    }
    
  return (
    <div>
      <div className="control-section">
        {/* Render the PDF Viewer */}
        <PdfViewerComponent
          ref={(scope) => {
            viewer = scope;
          }}
          id="container"
          documentPath={documentPath}
          serviceUrl={serviceUrl}
          style={style}
          toolbarSettings={{ showTooltip : true, toolbarItems: toolbarItems}}
          ajaxRequestInitiate = {ajaxRequestInitiate}
        >
            <Inject services={[ Toolbar, Magnification, Navigation, Annotation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch, FormFields, FormDesigner ]}/>
        </PdfViewerComponent>
      </div>
    </div>
  );
}
export default SyncfusionPDFViewer;